import axiosInstance from "../axiosInstance";

const BASE_URL = "/finance/income-expenditure";

export const getIncomeExpenditure = async (params = {}) => {
  const res = await axiosInstance.get(BASE_URL, { params });
  return res.data;
};

export const getCashLookupAdvances = async (purpose = "in") => {
  const res = await axiosInstance.get(`${BASE_URL}/lookup/advances`, {
    params: { purpose },
    skipGlobalErrorToast: true,
  });
  return res.data;
};

export const getCashLookupPayments = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/lookup/payments`, {
    skipGlobalErrorToast: true,
  });
  return res.data;
};

export const createCashRecord = async (payload) => {
  const isFormData =
    typeof FormData !== "undefined" && payload instanceof FormData;
  const res = await axiosInstance.post(`${BASE_URL}/records`, payload, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
    timeout: isFormData ? 120_000 : 30_000,
  });
  return res.data;
};
